import { styled, Box } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const { DARK_CONTAINER_FIELDS_ON_CARD, LIGHT_CONTAINER_FIELDS_ON_CARD } = COLORS;

export const DownloadBannerCont = styled(Box)(({ theme }) => ({
  border: 'none',
  borderImageSlice: '1',
  backgroundOrigin: 'border-box',
  backgroundClip: 'content-box, border-box',
  borderRadius: '10px !important',
  background: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_ON_CARD : LIGHT_CONTAINER_FIELDS_ON_CARD,
  padding: '5px',
}));

export const DownloadCont = styled(Box)(({ theme }) => ({
  margin: 10,
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.down(960)]: {
    flexDirection: 'column',
  },
}));

export const AdsImg = styled('img')(({ theme }) => ({
  width: 80,
  height: 100,
  marginRight: 10,
  [theme.breakpoints.down(960)]: {
    marginBottom: 10,
  },
}));

export const ButtonCont = styled(Box)(({ theme }) => ({
  marginLeft: 'auto',
  display: ' flex',
  gap: 10,
  [theme.breakpoints.down(1200)]: {
    marginTop: 10,
    marginLeft: 'unset',
    flexDirection: 'column',
    gap: 'unset',
  },
}));
